export default "/_next/static/images/2ac2876e9ce7751235fabcfdb4d2dda0.svg";